import React from 'react';

function Legal() {
  return (
    <>
      <section className="page-hero">
        <h1>Legal Documentation</h1>
        <p>Terms, policies, and legal information for the AGRO-INVEST platform.</p>
      </section>

      <div className="page-content">
        <div className="page-image">
          <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80" alt="Trust and compliance" />
        </div>
        <h2>Terms of Service</h2>
        <p>By using the AGRO-INVEST platform, you agree to our terms of service. These govern your use of farmer registration, supplier vouchers, investor marketplace, and all platform features.</p>

        <h2>Privacy Policy</h2>
        <p>AGRO-INVEST is committed to protecting your data. Farmer and investor information is stored securely. We use data only for AI risk evaluation, voucher financing, and platform operations. We do not sell your personal information.</p>

        <h2>Data Consent</h2>
        <p>Farmers provide digital consent before submitting registration data. Consent covers collection of personal information, farm data, GPS coordinates, and images for verification and risk assessment.</p>

        <h2>Financial Transactions</h2>
        <p>All financial transactions are logged for audit and compliance. Voucher redemptions and investment contributions are tracked and traceable.</p>

        <h2>Contact</h2>
        <p>For legal inquiries, contact us at +237 6 51 41 27 72.</p>
      </div>
    </>
  );
}

export default Legal;
